import { Description } from './description';
import { LocalDocument } from './local.document';

/**
 * The public document used in download
 */
export class PublicDocument {
    /**
     * The public document id
     */
    id: number;
    /**
     * The plan
     */
    plan: Description;
    /**
     * The local document
     */
    document: LocalDocument;
    /**
     * The description
     */
    description: string;
}